module.exports = __webpack_public_path__ + "static/media/tavi_logo_big.e923f030.png";